var baseurl = $('body').data('baseurl'),
    template = document.querySelector('#message-template'),
    notifs = {
        information: {
            type: 'info',
            icon: 'far fa-comment',
            title: 'Información'
        },
        success: {
            type: 'success',
            icon: 'fas fa-check',
            title: 'Información'
        },
        error: {
            type: 'danger',
            icon: 'fas fa-times',
            title: 'Error'
        },
        warning: {
            type: 'warning',
            icon: 'fas fa-exclamation-triangle',
            title: 'Información'
        }
    };

// Una navegación o descarga protegida también debe avisar a las otras pestañas.
(function () {
    var url = new URL(window.location.href);
    if (url.searchParams.get('sesion') !== 'caducada') {
        return;
    }
    url.searchParams.delete('sesion');
    window.history.replaceState(null, '', url.href);
    try {
        if ('BroadcastChannel' in window) {
            var canal = new BroadcastChannel('alumnoslic:sesion:' + baseurl);
            canal.postMessage('sesion-vencida');
            canal.close();
        }
    } catch (error) {
        // El login sigue disponible aunque no se pueda avisar a otras pestañas.
    }
})();

function notificacion(tipo, mensaje) {
    var tagIcono = template.content.querySelector('.notif-icono');
    var tagTitulo = template.content.querySelector('.notif-titulo');
    var tagMensaje = template.content.querySelector('.notif-mensaje');

    tagIcono.innerHTML = '<i class="' + notifs[tipo].icon + ' text-' + notifs[tipo].type + '"></i>';
    tagTitulo.textContent = notifs[tipo].title;
    tagMensaje.textContent = mensaje;

    var clone = document.importNode(template.content, true);

    document.querySelector('.list-notifications').appendChild(clone);
    $('.toast').toast('show');
    $('.toast').on('hidden.bs.toast', function() {
        $(this).remove();
    });
}

$(window).on('load', function() {
    var messages = $('#login-messages').data('messages');
    console.log(messages);
    if (messages.length > 0) {
        messages.forEach(function(el) {
            console.log(el);
            notificacion('error', el);
        });
    }
});
